// ==============================|| OVERRIDES - TYPOGRAPHY ||============================== //

import { Theme } from '@mui/material';

export default function Typography(theme: Theme) {
  return {
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: 12
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: theme.palette.custom.linkColor,
          textDecoration: 'underline',
          cursor: 'pointer'
        }
      }
    }
  };
}
